// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Js_exn = require("rescript/lib/js/js_exn.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var Expln_utils_data = require("../../rescript-utils/main/Expln_utils_data.bs.js");
var Belt_MutableStack = require("rescript/lib/js/belt_MutableStack.js");
var Caml_js_exceptions = require("rescript/lib/js/caml_js_exceptions.js");

function parseXmlFromStr(str) {
  return new DOMParser().parseFromString(str, "text/xml");
}

function elementGetAttrs(element) {
  var res = [];
  var attrs = element.attributes;
  if (attrs !== undefined) {
    for(var i = 0 ,i_finish = attrs.length; i < i_finish; ++i){
      var attr = attrs.item(i);
      if (!(attr == null)) {
        res.push([
              attr.name,
              attr.value
            ]);
      }
      
    }
  }
  return Belt_MapString.fromArray(res);
}

function parseStrExn(str) {
  var doc = parseXmlFromStr(str);
  var root = doc.documentElement;
  var match = Expln_utils_data.traverseTree(Belt_MutableStack.make(undefined), root, (function (param, node) {
          if (node.nodeType !== 1) {
            return ;
          }
          var children = [];
          var cNodes = node.childNodes;
          for(var i = 0 ,i_finish = cNodes.length; i < i_finish; ++i){
            var cNode = cNodes.item(i);
            if (!(cNode == null) && (cNode.nodeType === 1 || cNode.nodeType === 3)) {
              children.push(cNode);
            }
            
          }
          return children;
        }), undefined, (function (parents, node) {
          var xmlNode = node.nodeType === 1 ? ({
                TAG: /* Node */0,
                name: node.tagName,
                attrs: elementGetAttrs(node),
                children: []
              }) : (
              node.nodeType === 3 ? ({
                    TAG: /* Text */1,
                    _0: node.nodeValue
                  }) : Js_exn.raiseError("Node type of " + String(node.nodeType) + " is not expected here.")
            );
          var match = Belt_MutableStack.top(parents);
          if (match !== undefined && match.TAG === /* Node */0) {
            match.children.push(xmlNode);
          }
          Belt_MutableStack.push(parents, xmlNode);
        }), (function (parents, param) {
          if (Belt_MutableStack.size(parents) === 1) {
            return Belt_MutableStack.pop(parents);
          } else {
            Belt_MutableStack.pop(parents);
            return ;
          }
        }), undefined);
  var rootXmlNodeOpt = match[1];
  if (rootXmlNodeOpt !== undefined) {
    return rootXmlNodeOpt;
  } else {
    return Js_exn.raiseError("Got None as a result of parsing.");
  }
}

function parseStr(str) {
  var exToError = function (ex) {
    var msg;
    if (ex !== undefined) {
      var msg$1 = Caml_option.valFromOption(ex).message;
      msg = msg$1 !== undefined ? msg$1 : "no error message";
    } else {
      msg = "no error message";
    }
    return {
            TAG: /* Error */1,
            _0: msg
          };
  };
  try {
    return {
            TAG: /* Ok */0,
            _0: parseStrExn(str)
          };
  }
  catch (raw_ex){
    var ex = Caml_js_exceptions.internalToOCamlException(raw_ex);
    if (ex.RE_EXN_ID === Js_exn.$$Error) {
      return exToError(Caml_option.some(ex._1));
    } else {
      return exToError(Caml_js_exceptions.as_js_exn(ex));
    }
  }
}

exports.parseStr = parseStr;
/* No side effect */
